import React, { useEffect } from "react";
import Particles from "particles.js";

const Background = () => {
  useEffect(() => {
    window.particlesJS.load("particles-js", "/particles.json");
  }, []);

  return <div id="particles-js" className="particles-container"></div>;
};

export default Background;
